<template>
    <div>
        <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item>会员卡维护</el-breadcrumb-item>
            <el-breadcrumb-item>会员卡管理</el-breadcrumb-item>
        </el-breadcrumb>
        <el-card>
            <el-row :gutter="0">
                <el-col :span="10">
                    <el-input placeholder="请输入查询内容" v-model="queryInfo.query" class="input-with-select" clearable
                        style="width:300px " @clear="getvipList" @change="getvipList">
                        <el-button slot="append" icon="el-icon-search" @click="getvipList"></el-button>
                    </el-input>
                </el-col>
                <el-col :span="4">
                    <el-button type="primary" @click="get_vip_edit" v-if="false">添加会员卡</el-button>
                </el-col>
            </el-row>
            <el-row :gutter="0" class="el_row_two">
                <el-col :span="24">
                    <el-table :data="vipList" style="width: 100%" border stripe>
                        <el-table-column prop="uid" label=" 序号" width="80"></el-table-column>
                        <el-table-column prop="vip_bianhao" label=" 编号" width="120"></el-table-column>
                        <el-table-column prop="vip_name" label="会员卡名称"></el-table-column>
                        <el-table-column prop="vip_mob" label="手机"></el-table-column>
                        <el-table-column prop="vip_addr" label="地址"></el-table-column>
                        <el-table-column prop="add_time" label="加入时间"></el-table-column>
                        <el-table-column label="操作">
                            <template v-slot="scope">
                                <el-tooltip class="item" effect="dark" content="修改" placement="top" :enterable="false">
                                    <el-button type="primary" icon="el-icon-edit" @click="showEditDialog(scope.row.uid)"
                                        circle size="mini"></el-button>
                                </el-tooltip>
                                <el-tooltip class="item" effect="dark" content="删除" placement="top" :enterable="false">
                                    <el-button type="danger" icon="el-icon-delete" circle size="mini"
                                        @click="deleteForm(scope.row.uid)"></el-button>
                                </el-tooltip>
                                <!-- <el-tooltip class="item" effect="dark" content="设置为白名单" placement="top" :enterable="false">
                  <el-button type="danger" icon="el-icon-coordinate" circle size="mini"å
                    @click="baiMingdan(scope.row.uid,scope.row.vip_flag_baiMingdan)"></el-button>
                </el-tooltip> -->
                                <el-tooltip class="item" effect="dark" content="预约登记" placement="top" :enterable="false">
                                    <el-button type="success" icon="el-icon-orange" @click="showYuyueDialog(scope.row.uid)"
                                        circle size="mini"></el-button>
                                </el-tooltip>
                            </template>
                        </el-table-column>
                    </el-table>
                </el-col>
            </el-row>
            <!-- 分页 -->
            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                :current-page.sync="queryInfo.pageNum" :page-sizes="[10, 50]" :page-size="queryInfo.pageSize"
                layout="total, sizes, prev, pager, next, jumper" :total="total">
                <!--分页组件，其中handleSizeChange 条数下拉触发事件，  handleCurrentChange  选择分页出发事件 currentPage2 当前页绑定 page-sizes 下拉显示列表 page-size 每页多少条绑定 layout 显示分页的元素 total 合计条数绑定  -->
            </el-pagination>

            <!-- 添加会员卡部分 -->
            <!-- 管理调用 -->
            <!-- <el-dialog title="添加会员卡" :visible.sync="addDialogVisible" width="50%" @close="addDoalogClosed">
                <vipAdd ref="vipAdd" @getvipNewUid="getvipNewUid" @closevip="closevip" :diaoyongType="1"
                    :key="datekey" :editUid="editUid" :caozuoType="caozuoType">
                </vipAdd>
            </el-dialog> -->
            <!-- <el-dialog title="预约登记" :visible.sync="yuyueDialogVisible" width="50%" @close="addDoalogClosed">
                <yuyueAdd ref="yuyueAdd" @getYuyueNewUid="getYuyueNewUid" @closevip="closeYuyue" :diaoyongType="1"
                    :key="datekey" :editUid="editUid" :caozuoType="caozuoType">
                </yuyueAdd>
            </el-dialog> -->
        </el-card>
    </div>
</template>
<script>
// import vipAdd from './module/huiyuanka_add.vue'
// import yuyueAdd from './module/yuyue_add.vue'
import { checkMobileTest, checkSfzId } from './config/validator';
import { ref } from 'vue';
export default {
    components: {
        // vipAdd: vipAdd
        // yuyueAdd: yuyueAdd
    },
    data() {
        return {
            datekey: Date.now(),

            // 获取用户列表参数
            queryInfo: {
                C_type: 'get_list',
                C_table_name: 'vip_list',
                query: '',
                pageNum: 1,
                pageSize: 10,
                qiye_uid: window.sessionStorage.getItem('qiye_uid')
            },
            huifang_isDisable: false,
            add_isDisable: false,
            vipList: [],
            xiaoquList: [],
            //  recordCount: 0,
            total: 0,
            addDialogVisible: false,
            editDialogVisible: false,
            huifangDialogVisible: false,

            // 用于设置回访页面滑块值
            //  添加表单数据项
            huifangForm: {
                C_type: 'huifang_add',
                huifang_vip_uid: 0,
                huifang_title: '',
                hufiang_memo: '',
                huifang_genjin: 1,
                huifang_switch: true
            },
            caozuoType: 0, // 操作类型 1 是添加 2是删除
            editUid: 0, // 修改uid
            addForm: {
                C_type: 'vip_add',
                uid: 0,
                vip_bianhao: '',
                vip_name: '',
                vip_mob: '',
                vip_addr: '',
                vip_sfz_bianhao: '',
                vip_level: '',
                vip_memo: '',
                username: '',
                password: '123456'
            },
            // 用于修改数据绑定
            editForm: {},
            // 表单规则项
            addFormRules: {
                vip_name: [
                    { required: true, message: '请输入会员卡名称', trigger: 'blur' },
                    { min: 2, max: 20, message: '必须2到20位字符 ', trigger: 'blur' }
                ],

                vip_mob: [
                    {
                        validator: checkMobileTest.bind(
                            this.addForm && this.addForm.vip_mob
                        )
                    }
                ],
                vip_sfz_bianhao: [
                    {
                        validator: checkSfzId.bind(
                            this.addForm && this.addForm.vip_sfz_bianhao
                        )
                    }
                ]
            },

            editFormRules: {

            }
        };
    },
    created() {
        this.getvipList()
    },

    methods: {
        closevip(data) {
            this.addDialogVisible = false
        },
        getvipNewUid(data) {
            // 会员卡添加返回的结果，可以读取会员卡信息，在这里，只需要关闭窗口就好
            this.getvipList()
            this.addDialogVisible = false
            console.log(100, data)
        },
        async get_vip_edit() {
            this.addDialogVisible = true; // 要先打开才能调用
            // 通过更改组件的key 值，强制组件进行实时更新，每次出发create 函数
            this.datekey = Date.now()
            this.editUid = 0
            this.caozuoType = 1
            // 
        },
        async getvipList() {
            const { data: res } = await this.$http.get('get_api', {
                params: this.queryInfo
            });
            // console.log(JSON.parse(res.data)[0].dataList)
            this.vipList = JSON.parse(res.data)[0].dataList

            if (!this.vipList) return;
            this.vipList.forEach(function (item) {
                item.yong_flag = item.yong_flag === 1;
            });

            this.total = JSON.parse(res.data)[0].total;

            // console.log(this.total)
        },
        //  分页第一项下拉触发

        handleSizeChange(newSize) {
            this.queryInfo.pageSize = newSize;
            this.getvipList();
        },
        // 选择页数触发
        handleCurrentChange(newPage) {
            this.queryInfo.pageNum = newPage;
            this.getvipList();
        },
        showEditDialog(uid) {
            // this.vipInfo(uid);
            this.editUid = uid // 写uid
            this.caozuoType = 2

            this.datekey = Date.now() // 强制更新
            this.addDialogVisible = true;
        },
        addDoalogClosed() {
            this.$refs.vipAdd.resetForm();
        },
        huifangDoalogClosed() {
            this.$refs.huifangFormRef.resetFields();
        },
        showHuifangDialog(uid) {
            this.huifangDialogVisible = true;
            this.vipInfo(uid);
        },
        async Info(uid) {
            const { data: res } = await this.$http.get('get_api', {
                params: { C_table_name: 'vip_info', uid: uid, C_type: 'get_info' }
            });
            // console.log(JSON.parse(res.data))
            console.log(res.data);
            if (JSON.parse(res.data)[0].status !== 200) {
                return this.$message.error('读取失败');
            }
            this.editForm = JSON.parse(res.data)[0].data[0];
            this.huifangForm.huifang_vip_uid = JSON.parse(res.data)[0].data[0].uid;
        },

        async deleteForm(vipUid) {
            // 此处通过异步获取操作行为，而不用then ，来避免异步嵌套
            // 异步操作有2个，1个对话框等待，1个是网络请求
            const comfirmResult = await this.$confirm(
                '确定删除该条记录, 是否继续?',
                '提示',
                {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }
            ).catch(err => err);
            console.log(comfirmResult);
            if (comfirmResult === 'cancel') return this.$message.info('已经取消删除');
            const { data: res } = await this.$http.post('api', {
                C_type: 'record_delete',
                C_table_name: 'vip_del',
                C_data1: vipUid
            });
            if (JSON.parse(res.data)[0].status !== 200) {
                this.$message.error('删除失败');
                return;
            }
            this.$message.success('删除成功');
            this.getvipList();
        },

        // 设置白名单
        async baiMingdan(vipUid, baiMingdanFlag) {
            // 此处通过异步获取操作行为，而不用then ，来避免异步嵌套
            // 异步操作有2个，1个对话框等待，1个是网络请求
            var flag = 0
            if (baiMingdanFlag) flag = 0
            else flag = 1
            const comfirmResult = await this.$confirm(
                '确定要设置为白名单吗, 是否继续?',
                '提示',
                {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }
            ).catch(err => err);
            console.log(comfirmResult);
            if (comfirmResult === 'cancel') return this.$message.info('已经取消');

            const { data: res } = await this.$http.post('api', {
                C_type: 'vip_baiMingdan',
                vipUid: vipUid,
                baiMingdanFlag: flag
            });
            if (JSON.parse(res.data)[0].status !== 200) {
                this.$message.error('设置失败');
                return;
            }
            this.$message.success('设置成功');
            this.getvipList();
        }
    }
};
</script>
<style lang="less" scoped>
.card_two {
    margin-top: 30px;
    box-shadow: none !important;
    background-color: #f2f6fc;
}

.el_row_two {
    margin-top: 30px;
}
</style>
